import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { UserService } from 'src/app/services/User.service';
import { ANGULAR_MODULES } from 'src/app/Shared/shared-imports';
import { SharedHTMLSettingsDataService } from 'src/app/Shared/sharedHTMLSettingsData.service';

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  standalone: true,
  imports: [ANGULAR_MODULES]
})
export class ResetpasswordComponent implements OnInit, OnDestroy {
  resetForm!: FormGroup;
  @Input() userId;
  @Input() currentPassword;
  @Output() closeResetModal = new EventEmitter<any>();  
  private subscriptions: Subscription[] = [];

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private toastr: ToastrService,
    private sharedHTMLSettings: SharedHTMLSettingsDataService
  ) { }

  ngOnInit(): void {
    this.resetForm = this.fb.group({
      newPassword: ['', [Validators.required, Validators.minLength(8), this.passwordStrengthValidator]],
      confirmPassword: ['', Validators.required]
    }, { validators: this.matchPasswords });
  }

  passwordStrengthValidator(control: AbstractControl): { [key: string]: boolean } | null {
    const value = control.value;
    if (!value) return null;
    const hasUpperCase = /[A-Z]/.test(value);
    const hasNumber = /\d/.test(value);
    const hasSpecialChar = /[\W_]/.test(value);
    const valid = hasUpperCase && hasNumber && hasSpecialChar;
    return !valid ? { weakPassword: true } : null;
  }

  matchPasswords(group: AbstractControl): { [key: string]: boolean } | null {
    const password = group.get('newPassword')?.value;
    const confirm = group.get('confirmPassword')?.value;
    return password === confirm ? null : { passwordMismatch: true };
  }

  onSubmit(): void {
    if (this.resetForm.valid) {
      const { newPassword } = this.resetForm.value;
      if (newPassword != this.currentPassword) {
        var obj = {
          UserId: this.userId,
          OldPassword: this.currentPassword,
          NewPassword: newPassword,
          EmailPassword: true
        }
        this.subscriptions.push(this.userService.ResetPassword(obj).subscribe({
          next: () => {
            this.closeResetModal.emit();
            this.toastr.success("Password successfully reset! Please login to the application using new password.", $localize`Success`, this.sharedHTMLSettings.ToasterConfig);
          },
          error: err => {
            this.toastr.error("Something went wrong. Please try again.", $localize`Error`, this.sharedHTMLSettings.ToasterConfig);
          }
        }));
      } else {
        this.toastr.info("New password should not be same as old password.", $localize`Info`, this.sharedHTMLSettings.ToasterConfig);
      }
    }
  }

  close() {
    this.closeResetModal.emit();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }
}
